import {
    ActionStateValues,
    ButtonType,
    ComponentsType,
    DeepPartial,
    PerthNowColourMap,
    TheWestColourMap,
    tokens,
} from '@news-mono/design-tokens'
import { Product } from 'libs/web-common/src/__product'

interface featureTheme {
    sectionValues: any
    colors: {
        background: {
            primary: string
            secondary: string
        }
        brand: string
        text: any
        actions: {
            button: ButtonType
            link: ActionStateValues
        }
        borders: any
        icons: {
            default: string
            hover: string
        }
        components?: ComponentsType
    }
}

export function getStreamerScreamerThemeValues() {
    const theme = tokens['thewest'].colors as TheWestColourMap
    const pnTheme = tokens['perthnow'].colors as PerthNowColourMap
    const { palette } = theme
    const { palette: pnPalette } = pnTheme

    return {
        colors: {
            background: {
                primary: palette.transparent,
                secondary: pnTheme.palette.streamerScreamer.gradientBrown,
            },
            brand: palette.white,
            text: {
                primary: palette.white,
                secondary: palette.greyDolphin,
                tertiary: palette.white,
                heading: palette.white,
            },
            actions: {
                button: {
                    primary: {
                        background: {
                            default: pnPalette.pinkThulite,
                            hover: palette.transparent,
                            active: palette.transparent,
                            focus: palette.transparent,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                    },
                    secondary: {
                        background: {
                            default: pnTheme.palette.streamerScreamer.orange,
                            hover: pnTheme.palette.streamerScreamer.red,
                            active: palette.white,
                            focus: palette.white,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                    },
                },
                link: {
                    default: palette.white,
                    active: palette.white,
                    focus: palette.white,
                    hover: palette.white,
                },
            },
            borders: {
                primary: palette.transparent,
                secondary: palette.white,
            },
            icons: {
                default: palette.greyHippo,
                hover: palette.westblue,
            },
            components: {
                playOfTheDay: {
                    background: pnTheme.palette.streamerScreamer.gradientBrown,
                    text: palette.white,
                    banner: {
                        background: palette.transparent,
                    },
                },
            },
        },
    }
}

export function getCNBCThemeValues(): featureTheme {
    //We are using almost all the colors inside the Grand Final Theme, aside from the primary background.
    const theme = tokens['thewest'].colors as TheWestColourMap
    const palette = theme.palette.grandFinal
    const cnbcPalette = theme.palette.cnbc

    return {
        sectionValues: { primaryColor: palette.lightBlue },
        colors: {
            background: {
                primary: cnbcPalette.darkBlue,
                secondary: cnbcPalette.darkBlue,
            },
            brand: palette.white,
            text: {
                primary: palette.white,
                secondary: palette.lightBlue,
                tertiary: palette.darkBlue,
                heading: palette.white,
            },
            actions: {
                button: {
                    primary: {
                        background: {
                            default: palette.lightBlue,
                            hover: palette.transparent,
                            active: palette.transparent,
                            focus: palette.transparent,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.lightBlue,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                        border: {
                            default: palette.white,
                            hover: palette.lightBlue,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                    },
                    secondary: {
                        background: {
                            default: palette.gradientBlue,
                            hover: palette.white,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                        border: {
                            default: palette.lightBlue,
                            hover: palette.white,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                    },
                },
                link: {
                    default: palette.white,
                    active: palette.lightBlue,
                    focus: palette.white,
                    hover: palette.lightBlue,
                },
            },
            borders: {
                primary: palette.lightBlueBorderTransparent,
                secondary: cnbcPalette.darkBlue,
            },
            icons: {
                default: palette.lightBlue,
                hover: palette.white,
            },
        },
    }
}

export function getCommonwealthGamesValues(): featureTheme {
    const theme = tokens['thewest'].colors as TheWestColourMap
    const pnTheme = tokens['perthnow'].colors as PerthNowColourMap
    const { palette } = theme
    const { palette: pnPalette } = pnTheme

    return {
        sectionValues: {
            primaryColor: palette.commonWealthGames.cardTextHover,
        },
        colors: {
            background: {
                primary: palette.commonWealthGames.purple,
                secondary: palette.commonWealthGames.purple,
            },
            brand: palette.white,
            text: {
                primary: palette.white,
                secondary: palette.greyDolphin,
                tertiary: palette.white,
                heading: palette.white,
            },
            actions: {
                button: {
                    primary: {
                        background: {
                            default: pnPalette.pinkThulite,
                            hover: palette.transparent,
                            active: palette.transparent,
                            focus: palette.transparent,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                    },
                    secondary: {
                        background: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                    },
                },
                link: {
                    default: palette.white,
                    active: palette.white,
                    focus: palette.white,
                    hover: palette.commonWealthGames.cardBorderTransparent,
                },
            },
            borders: {
                primary: palette.commonWealthGames.cardBorderTransparent,
                secondary: palette.white,
            },
            icons: {
                default: palette.greyHippo,
                hover: palette.westblue,
            },
            components: {
                playOfTheDay: {
                    background: palette.commonWealthGames.purple,
                    text: palette.white,
                    banner: {
                        background: palette.commonWealthGames.purple,
                    },
                },
            },
        },
    }
}

export function getQueensLegacyThemeValues(): featureTheme {
    const theme = tokens['thewest'].colors as TheWestColourMap
    const palette = theme.palette.queensLegacy

    return {
        sectionValues: { primaryColor: palette.white },
        colors: {
            background: {
                primary: palette.pink,
                secondary: palette.gradientMaroon,
            },
            brand: palette.white,
            text: {
                primary: palette.white,
                secondary: palette.white,
                tertiary: palette.white,
                heading: palette.white,
            },
            actions: {
                button: {
                    primary: {
                        background: {
                            default: palette.maroon,
                            hover: palette.transparent,
                            active: palette.transparent,
                            focus: palette.transparent,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                    },
                    secondary: {
                        background: {
                            default: palette.gradientMaroon,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.maroon,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                    },
                },
                link: {
                    default: palette.white,
                    active: palette.white,
                    focus: palette.white,
                    hover: palette.white,
                },
            },
            borders: {
                primary: palette.whiteBorderTransparent,
                secondary: palette.maroon,
            },
            icons: {
                default: palette.white,
                hover: palette.white,
            },
        },
    }
}

export function getGrandFinalThemeValues({
    product,
}: {
    product: Product
}): featureTheme {
    const theme = tokens[product].colors as TheWestColourMap | PerthNowColourMap
    const palette = theme.palette.grandFinal
    const theWestPalette = tokens['thewest'].colors

    return {
        sectionValues: { primaryColor: palette.lightBlue },
        colors: {
            background: {
                primary: theWestPalette.palette.grandFinal.mediumBlue,
                secondary: palette.gradientBlue,
            },
            brand: palette.white,
            text: {
                primary: theWestPalette.palette.customBodyTextColor,
                secondary: theWestPalette.palette.grandFinal.lightBlue,
                tertiary: theWestPalette.palette.customAuthorTextColor,
                heading: palette.white,
            },
            actions: {
                button: {
                    primary: {
                        background: {
                            default: palette.lightBlue,
                            hover: palette.transparent,
                            active: palette.transparent,
                            focus: palette.transparent,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.lightBlue,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                        border: {
                            default: palette.white,
                            hover: palette.lightBlue,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                    },
                    secondary: {
                        background: {
                            default: palette.gradientBlue,
                            hover: palette.white,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                        border: {
                            default: palette.lightBlue,
                            hover: palette.white,
                            active: palette.lightBlue,
                            focus: palette.lightBlue,
                        },
                    },
                },
                link: {
                    default: palette.white,
                    active: palette.lightBlue,
                    focus: palette.white,
                    hover: palette.lightBlue,
                },
            },
            borders: {
                primary: palette.lightBlueBorderTransparent,
                secondary: palette.lightBlueBorderTransparent,
            },
            icons: {
                default: palette.lightBlue,
                hover: palette.white,
            },
            components: {
                playOfTheDay: {
                    background: theWestPalette.palette.grandFinal.mediumBlue,
                    text: palette.white,
                    banner: {
                        background:
                            theWestPalette.palette.grandFinal.mediumBlue,
                    },
                },
            },
        },
    }
}

export function getGrandFinalFreoValues() {
    const theme = tokens['thewest'].colors as TheWestColourMap
    const { palette } = theme
    const { grandFinalFreo: freoPalette } = palette

    return {
        sectionValues: { primaryColor: freoPalette.lightPurple },
        colors: {
            background: {
                primary: freoPalette.purple,
                secondary: freoPalette.purple,
            },
            brand: palette.white,
            text: {
                primary: palette.white,
                secondary: freoPalette.lightPurple,
                tertiary: palette.customAuthorTextColor,
                heading: palette.white,
            },
            actions: {
                button: {
                    primary: {
                        background: {
                            default: freoPalette.lightPurple,
                            hover: palette.transparent,
                            active: palette.transparent,
                            focus: palette.transparent,
                        },
                        text: {
                            default: palette.white,
                            hover: freoPalette.lightPurple,
                            active: freoPalette.lightPurple,
                            focus: freoPalette.lightPurple,
                        },
                        border: {
                            default: palette.white,
                            hover: freoPalette.lightPurple,
                            active: freoPalette.lightPurple,
                            focus: freoPalette.lightPurple,
                        },
                    },
                    secondary: {
                        background: {
                            default: palette.white,
                            hover: palette.white,
                            active: freoPalette.lightPurple,
                            focus: freoPalette.lightPurple,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: freoPalette.lightPurple,
                            focus: freoPalette.lightPurple,
                        },
                        border: {
                            default: freoPalette.lightPurple,
                            hover: palette.white,
                            active: freoPalette.lightPurple,
                            focus: freoPalette.lightPurple,
                        },
                    },
                },
                link: {
                    default: palette.white,
                    active: freoPalette.lightPurple,
                    focus: palette.white,
                    hover: freoPalette.lightPurple,
                },
            },
            borders: {
                primary: freoPalette.linePurple,
                secondary: freoPalette.linePurple,
            },
            icons: {
                default: palette.white,
                hover: palette.white,
            },
        },
    }
}

export function getDevelopingNewsTheme(themeColour: string) {
    const { palette } = tokens['thewest'].colors as TheWestColourMap

    const developingNewsTheme = {
        sectionValues: { primaryColor: palette.white },
        colors: {
            background: {
                primary: palette.developingNews.grey.background,
                secondary: palette.transparent,
            },
            brand: palette.white,
            text: {
                primary: palette.white,
                secondary: palette.developingNews.grey.kickerFont,
                tertiary: palette.customAuthorTextColor,
                heading: palette.white,
            },
            actions: {
                button: {
                    primary: {
                        background: {
                            default: palette.white,
                            hover: palette.transparent,
                            active: palette.transparent,
                            focus: palette.transparent,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.lightSilver,
                            hover: palette.lightSilver,
                            active: palette.lightSilver,
                            focus: palette.lightSilver,
                        },
                    },
                    secondary: {
                        background: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        text: {
                            default: palette.white,
                            hover: palette.white,
                            active: palette.white,
                            focus: palette.white,
                        },
                        border: {
                            default: palette.lightSilver,
                            hover: palette.lightSilver,
                            active: palette.lightSilver,
                            focus: palette.lightSilver,
                        },
                    },
                },
                link: {
                    default: palette.white,
                    active: palette.white,
                    focus: palette.white,
                    hover: palette.white,
                },
            },
            borders: {
                primary: palette.lightSilver,
                secondary: palette.lightSilver,
            },
            icons: {
                default: palette.white,
                hover: palette.white,
            },
        },
    }

    switch (themeColour) {
        case 'red':
            developingNewsTheme.colors.background.primary =
                palette.developingNews.red.background
            developingNewsTheme.colors.text.secondary =
                palette.developingNews.red.kickerFont
            return developingNewsTheme
        case 'blue':
            developingNewsTheme.colors.background.primary =
                palette.developingNews.blue.background
            developingNewsTheme.colors.text.secondary =
                palette.developingNews.blue.kickerFont
            return developingNewsTheme
        default:
            return developingNewsTheme
    }
}

export function getBestAustralianYarnTheme(): {
    colors: DeepPartial<TheWestColourMap>
} {
    const { palette } = tokens['thewest'].colors as TheWestColourMap

    return {
        colors: {
            actions: {
                link: {
                    default: palette.white,
                    hover: palette.hollywoodCerise,
                },
            },
            background: {
                primary: palette.bestAustralianYarn.velvet,
            },
            text: {
                primary: palette.white,
                heading: palette.white, // card headline
                secondary: palette.bestAustralianYarn.lilac, // kicker
            },
        },
    }
}

export function getLifestyleThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.bauhausLifestyle,
            tag: {
                primaryColor: tokens.sevennews.colors.palette.bauhausLifestyle,
            },
            link: {
                primaryColor: tokens.sevennews.colors.palette.bauhausLifestyle,
            },
        },
    }
}

export function getEntertainmentThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.bauhausEntertainment,
            tag: {
                primaryColor:
                    tokens.sevennews.colors.palette.bauhausEntertainment,
            },
            link: {
                primaryColor:
                    tokens.sevennews.colors.palette.bauhausEntertainment,
            },
        },
    }
}

export function getSportThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.bauhausSport,
            tag: { primaryColor: tokens.sevennews.colors.palette.bauhausSport },
            link: {
                primaryColor: tokens.sevennews.colors.palette.bauhausSport,
            },
        },
    }
}

export function getTechThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.bauhausTech,
            tag: { primaryColor: tokens.sevennews.colors.palette.bauhausTech },
            link: { primaryColor: tokens.sevennews.colors.palette.bauhausTech },
        },
    }
}

export function getPoliticsThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.bauhausPolitics,
            tag: {
                primaryColor: tokens.sevennews.colors.palette.bauhausPolitics,
            },
            link: {
                primaryColor: tokens.sevennews.colors.palette.bauhausPolitics,
            },
        },
    }
}

export function getBusinessThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.bauhausBusiness,
            tag: {
                primaryColor: tokens.sevennews.colors.palette.bauhausBusiness,
            },
            link: {
                primaryColor: tokens.sevennews.colors.palette.bauhausBusiness,
            },
        },
    }
}
export function getWorldThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.bauhausWorld,
            tag: {
                primaryColor: tokens.sevennews.colors.palette.bauhausWorld,
            },
            link: {
                primaryColor: tokens.sevennews.colors.palette.bauhausWorld,
            },
        },
    }
}
export function getBauhausDefaultThemeValues() {
    return {
        sectionValues: {
            primaryColor: tokens.sevennews.colors.palette.red,
            tag: { primaryColor: tokens.sevennews.colors.palette.red },
            link: { primaryColor: tokens.sevennews.colors.palette.red },
        },
    }
}
